export const types = {
    AUTOMFLOW: 'AUTOMFLOW',
    START: 'START',
    END: 'STOP',
    IF: 'IF',
    PROCESSFLOW:'PROCESSFLOW'

};